export default "__VITE_ASSET__C5Y3pEMQ__"